<script setup lang="ts">
const { t, locale } = useI18n()
const href = computed(() => locale.value === 'ky' ? 'https://xruby.kg/kg' : 'https://xruby.kg')
</script>

<template>
  <a
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    class="block rounded-lg p-5 no-underline"
    style="background: linear-gradient(140deg, #0C0F21, #1B1A2E)"
  >
    <h2 class="h4 mb-3 font-serif text-white">{{ t('widget.xruby_referral.title') }}</h2>
    <div class="mb-2 font-serif text-5xl font-black leading-none" style="color: #FF3D5C">
      {{ t('widget.xruby_referral.percent') }}
    </div>
    <p class="mb-4 text-sm leading-snug" style="color: rgba(255,255,255,0.8)">
      {{ t('widget.xruby_referral.description_before') }}
      <b class="text-white">{{ t('widget.xruby_referral.description_days') }}</b>
      {{ t('widget.xruby_referral.description_middle') }}
      <b class="text-white">{{ t('widget.xruby_referral.description_limit') }}</b>
      {{ t('widget.xruby_referral.description_after') }}
    </p>
    <span
      class="block rounded-lg py-3 text-center text-sm font-bold text-white"
      style="background: #C51625"
    >{{ t('widget.xruby_referral.button') }}</span>
  </a>
</template>
